export const formatApiResponse = (apiResponse: string) => {
  let newReponse = JSON.parse(apiResponse);
  newReponse = JSON.stringify(newReponse, null, 2);
  return newReponse;
}